export const TEST_ID = 'versionAvailabilityBanner';

export const V2_HOME_PATH = '/v2';
